import { ReactComponent as ApiPermission } from './apiPermissions.svg'

export default ApiPermission
